import React, { useEffect, useState } from "react";
import LoadingGif from "@public/img/loading.gif";
import { PublicListData } from "@/entry/server/user";
import { userRepo } from "@/repo/user-repo";
import { Link } from "react-router-dom";
import { ASSETS_BASE_URL } from "@/utils/constants";
import { Pagination } from "@/lib/api";
import PaginationView from "@/component/commom/pagination";

function ListsEmptyIcon() {
    return (
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="profile-panel__empty-icon">
            <path d="M20.901 16.4727H16.932" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.4009 3.46777V20.5318" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40089 3.46777V20.5318" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40099 16.4727H3.43199" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.901 12H16.527" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.473 12H6.57298" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40101 12H3.02701" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20.9011 7.47266H16.9861" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.40105 7.47266H3.48605" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M3 12C3 7.75736 3 5.63604 4.31802 4.31802C5.63604 3 7.75736 3 12 3C16.2426 3 18.364 3 19.682 4.31802C21 5.63604 21 7.75736 21 12C21 16.2426 21 18.364 19.682 19.682C18.364 21 16.2426 21 12 21C7.75736 21 5.63604 21 4.31802 19.682C3 18.364 3 16.2426 3 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default function Page() {
    var listsState = useState<PublicListData[]>([]);
    var lists = listsState[0];
    var setLists = listsState[1];
    var loadingState = useState<boolean>(true);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    var paginationState = useState<Pagination | undefined>(undefined);
    var pagination = paginationState[0];
    var setPagination = paginationState[1];
    var pageState = useState<number>(1);
    var page = pageState[0];
    var setPage = pageState[1];

    useEffect(function () {
        setLoading(true);
        userRepo.getLists(page).then(function (res) {
            setLists(res.data ? res.data : []);
            setPagination(res.pagination ? res.pagination : undefined);
            setLoading(false);
        });
    }, [page]);

    var handleDelete = function (id: number) {
        if (!window.confirm("آیا می خواهید این لیست را حذف کنید؟")) {
            return;
        }
        userRepo.deleteList(id).then(function (res) {
            if (res.status) {
                setLists(function (prev) {
                    return prev.filter(function (list) {
                        return list.id !== id;
                    });
                });
            }
        });
    };

    var bodyClassName = "profile-panel__body";
    if (loading || lists.length === 0) {
        bodyClassName = bodyClassName + " profile-panel__body--center";
    }

    return (
        <div className="profile-panel profile-lists">
            <div className="profile-lists__header">
                <h2 className="profile-lists__title">لیست‌های من</h2>
                <Link to="/profile/lists/create" className="profile-lists__add-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5 12H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>افزودن لیست</span>
                </Link>
            </div>

            <div className={bodyClassName}>
                {loading && (
                    <div className="profile-panel__loading">
                        <img src={LoadingGif} alt="loading" />
                    </div>
                )}

                {!loading && lists.length === 0 && (
                    <div className="profile-panel__empty">
                        <ListsEmptyIcon />
                        <p className="profile-panel__empty-title">
                            <span className="profile-panel__empty-title-accent">لیستی</span> وجود ندارد
                        </p>
                        <p className="profile-panel__empty-desc">
                            هیچ لیستی وجود ندارد. برای ایجاد لیست جدید{" "}
                            <Link to="/profile/lists/create" className="profile-lists__empty-link">اینجا</Link>
                            {" "}کلیک کنید.
                        </p>
                    </div>
                )}

                {!loading && lists.length > 0 && (
                    <div className="profile-lists__grid">
                        {lists.map(function (list) {
                            return (
                                <div key={list.id} className="profile-lists__grid-item">
                                    <ListItem list={list} onDelete={function () {
                                        handleDelete(list.id);
                                    }} />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {pagination && (
                <div className="profile-panel__pagination">
                    <PaginationView pagination={pagination} black={true} onChange={setPage} />
                </div>
            )}
        </div>
    );
}

function ListItem({ list, onDelete }: { list: PublicListData; onDelete: () => void }) {
    var emptySlots = list.movie_count < 6 ? 6 - list.movie_count : 0;

    return (
        <div className="profile-lists-card">
            <div className="profile-lists-card__thumbs">
                {list.thumbnails.map(function (thumbnail, index) {
                    var src = thumbnail.indexOf("http") === 0 ? thumbnail : ASSETS_BASE_URL + thumbnail;
                    var showOverlay = index >= 5 && list.movie_count > 6;

                    return (
                        <div key={index} className="profile-lists-card__thumb">
                            <div className="profile-lists-card__thumb-inner">
                                <img src={src} alt={list.name} />
                                {showOverlay && (
                                    <div className="profile-lists-card__thumb-overlay">
                                        <span>+{list.movie_count - 6}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}

                {Array.from({ length: emptySlots }).map(function (_, index) {
                    return (
                        <div key={"empty-" + index} className="profile-lists-card__thumb">
                            <div className="profile-lists-card__thumb-inner"></div>
                        </div>
                    );
                })}
            </div>

            <h3 className="profile-lists-card__name">{list.name}</h3>

            <div className="profile-lists-card__actions">
                <Link to={"/profile/lists/" + list.id + "/edit"} className="profile-lists-card__action profile-lists-card__action--edit">
                    ویرایش اطلاعات
                </Link>
                <Link to={"/profile/lists/" + list.id} className="profile-lists-card__action profile-lists-card__action--titles">
                    ویرایش عناوین
                </Link>
                <button type="button" onClick={onDelete} className="profile-lists-card__delete">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.23828 7.14258L6.19066 16.6664H13.8097L14.7621 7.14258" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M11.25 12.9167V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.75 12.9167V8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M3.80859 5.23875H7.61812M7.61812 5.23875L7.9365 3.9652C8.02925 3.59423 8.36257 3.33398 8.74495 3.33398H11.2532C11.6356 3.33398 11.9689 3.59423 12.0616 3.9652L12.38 5.23875M7.61812 5.23875H12.38M12.38 5.23875H16.1895" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </button>
            </div>
        </div>
    );
}
